import { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Msg } from 'react-weui';

import PropTypes from 'prop-types';
import Http from 'services/http2';
import AreaCode from '../components/areaCode';
import Validation from 'services/validation';
import Util from '../lib/util.js';

import ReactEcharts from 'echarts-for-react';
import StatisticsFns from '../functions/statistics';

import * as MobileActions from 'actions/index.ts';
import { withStyles } from '@material-ui/core/styles';
import Input from '@material-ui/core/Input';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Button from '@material-ui/core/Button';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import MenuItem from '@material-ui/core/MenuItem';
// import InputLabel from '@material-ui/core/InputLabel';
import AccountCircle from '@material-ui/icons/AccountCircle';
import InputAdornment from '@material-ui/core/InputAdornment';
import PhoneIphone from '@material-ui/icons/PhoneIphone';
import TextField from '@material-ui/core/TextField';
import Snackbar from '@material-ui/core/Snackbar';
import WarningIcon from '@material-ui/icons/Warning';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';

/* dev
http://open.weixin.qq.com/connect/oauth2/authorize?appid=wxf3cf604fbe16e419&redirect_uri=http%3A%2F%2Fdev.xiekeyun.com%2Fmp%2Fsurvey%2FQTN6220190418001&response_type=code&scope=snsapi_base&state=123#wechat_redirect
*/

let dayOption = [];
const erpOption = [
  { code: '1', text: '用友' },
  { code: '2', text: '金蝶' },
  { code: '3', text: '鼎捷' },
  { code: '4', text: 'SAP' },
  { code: '5', text: 'Oracle' },
  { code: '6', text: '其他' },
  { code: '7', text: '没有ERP' },
];
for (var i = 0; i < 30; i++) {
  let obj = {
    code: (i + 1).toString(),
    text: (i + 1).toString(),
  };
  dayOption.push(obj);
}
let basicAll = [
  {
    pageNum: 1,
    title: '',
    childList: [
      {
        num: 1,
        id: '1',
        type: 'text',
        txt: '您企业平均每天外发的采购订单数量约为',
        lastTxt: '张',
        placeholder: '订单数',
        value: '',
      },
      {
        num: 2,
        id: '2',
        type: 'checkbox',
        value: null,
        txt: '现在主要的订单发放工具为',
        option: [
          { id: 'A', name: '传真', checked: false },
          { id: 'B', name: '邮件', checked: false },
          { id: 'C', name: 'QQ或微信', checked: false },
          { id: 'D', name: '有系统管理', checked: false },
        ],
      },
      {
        num: 3,
        id: '7',
        type: 'radio',
        value: null,
        txt: '供应商绩效管理',
        option: [
          { id: 'A', name: '未开始供应商绩效' },
          { id: 'B', name: '部分手工统计' },
          { id: 'C', name: '有绩效管理系统' },
        ],
      },
    ],
  },
  {
    pageNum: 2,
    title: '供应商过程管理',
    childList: [
      {
        num: 4,
        id: '3',
        type: 'radio',
        txt: '供应商送货单格式管理',
        value: null,
        option: [
          { id: 'A', name: '供应商自有格式' },
          { id: 'B', name: '统一格式，手工打印' },
          { id: 'C', name: '有系统管理' },
        ],
      },
      {
        num: 5,
        id: '4',
        type: 'radio',
        txt: '供应商来料管控',
        value: null,
        option: [
          { id: 'A', name: '未能管控供应商提前来料和规范' },
          { id: 'B', name: '有系统管控供应商来料过程' },
        ],
      },
      {
        num: 6,
        id: '5',
        type: 'radio',
        txt: '分批送料计划',
        value: null,
        option: [
          { id: 'A', name: '不需要' },
          { id: 'B', name: '有需要未管理' },
          { id: 'C', name: '手工计划表' },
          { id: 'D', name: '有来料看板系统' },
        ],
      },
      {
        num: 7,
        id: '6',
        type: 'radio',
        txt: '来料条码/标签',
        value: null,
        option: [
          { id: 'A', name: '不需要' },
          { id: 'B', name: '有需要未管理' },
          { id: 'C', name: '供应商手工打印' },
          { id: 'D', name: '有条码系统' },
        ],
      },
    ],
  },
  {
    pageNum: 3,
    title: '',
    childList: [
      {
        num: 8,
        id: '8',
        type: 'select',
        value: '',
        txt: '每月完成对账的日期为',
        lastTxt: '日',
        placeholder: '天数',
        option: dayOption,
      },
      {
        num: 9,
        id: '9',
        type: 'radio',
        value: null,
        txt: '采购询价招标管理方式',
        option: [
          { id: 'A', name: '手工管理' },
          { id: 'B', name: '用邮件管理' },
          { id: 'C', name: '有招标系统管理' },
        ],
      },
      {
        num: 10,
        id: '10',
        type: 'radio',
        value: null,
        txt: '企业规模',
        option: [
          { id: 'A', name: '十亿以下' },
          { id: 'B', name: '十至五十亿' },
          { id: 'C', name: '五十亿以上' },
        ],
      },
      {
        num: 11,
        id: '99',
        type: 'select',
        value: '',
        txt: '公司ERP厂商',
        placeholder: '',
        option: erpOption,
      },
    ],
  },
];

const styles = theme => ({
  h2: {
    marginTop: '5px',
    textAlign: 'center',
    height: 45,
    lineHeight: '45px',
  },
  h3: {
    fontSize: '20px',
    height: 45,
    lineHeight: '45px',
    paddingLeft: '20px',
  },
  h4: {
    fontSize: '18px',
    height: 25,
    lineHeight: '25px',
    paddingLeft: '18px',
    fontWeight: 500,
  },
  quesTitle: {
    color: '#333',
    fontSize: '16px',
    marginBottom: 10,
    fontWeight: 800,
  },
  inputTxt: {
    width: 80,
    margin: '0 10px',
    fontSize: '14px',
  },
  button: {
    margin: '10px',
    flex: 1,
  },
  quesBox: {
    position: 'absolute',
    top: '0',
    bottom: 0,
    backgroundColor: '#fff',
    left: 0,
    right: 0,
    overflowY: 'auto',
  },
  quesList: {
    padding: '0px 20px 10px',
  },
  infoBox: {
    background: '#fafafa',
    borderRadius: '6px',
    overflow: 'hidden',
    border: ' 1px solid #f0f0f0',
    padding: '10px 20px 10px 30px',
  },
  infoInputBox: {
    position: 'relative',
  },
  infoTextField: {
    width: '100%',
    backgroundColor: '#fff',
  },
  quesSelect: {
    width: '100px',
    height: '30px',
    margin: '5px 10px 0 0',
    overflow: 'hidden',
    verticalAlign: 'unset',
  },
  pl16: {
    paddingLeft: '16px',
    marginTop: '5px',
  },
  message: {
    display: 'flex',
    alignItems: 'center',
  },
  warningIcon: {
    marginRight: '10px',
  },
  snackbarContent: {
    backgroundColor: '#f75b5b',
  },
  card: {
    margin: '0 20px 20px 20px',
    overflow: 'unset',
  },
  cardContent: {
    padding: '0',
  },
  fruitH4: {
    fontSize: '20px',
    padding: '10px 20px 0',
    color: '#20a8d8',
  },
  fruitBox: {
    fontSize: '14px',
    padding: '10px 20px',
  },
  fruitTitle: {
    fontSize: '16px',
    color: '#333',
  },
  fruitP: {
    color: '#777',
  },
  fruitRed: {
    color: '#f53c3a',
    textDecoration: 'underline',
  },
  labelRed: {
    color: '#f53c3a',
    position: 'absolute',
    left: '-14px',
    top: '50%',
    height: '14px',
    marginTop: '-14px',
  },
});

class Survey extends Component {
  constructor(props) {
    super(props);
    const { match } = props;
    this.qtnXkNo = match.params.id.trim();
    this.saveClick = this.saveClick.bind(this);
    this.nextClick = this.nextClick.bind(this);
    this.validationConfig = this.validationConfig.bind(this);
    this.state = {
      stepNum: 0,
      error: null,
      error2: null,
      showError: false,
      questionNum: 1,
      questionAll: Util.mergeAll([basicAll]),
      answerList: [],
      chartOpt1: {},
      userInfo: {
        userName: '',
        companyName: '',
        mobileArea: '',
        mobile: '',
        erpTypeCode: '',
        erpTypeName: '',
        // 'positionCode':'',
        // 'positionName':'',
      },
      resultData: {},
    };
    this.error = {};
    this.errorMsg = '';
  }

  init() {
    let { code, state } = Util.getParamObj(window.location.search);
    let postbody = {
      apiPath: '/getOpenId',
      code,
      state,
    };
    Http.post('/api/mp', postbody).then(response => {
      if (response.success) {
        this.getDetail();
      } else {
        this.setState({
          error: {
            type: 'warn',
            title: '请在微信公众号内访问。',
          },
        });
      }
    });
  }

  componentDidMount() {
    this.init();
  }

  getDetail() {
    let postbody = {
      apiPath: '/questionnaire/answer/getDetail',
      qtnXkNo: this.qtnXkNo,
    };
    this.setState({ error: null });
    Http.post('/api/mp', postbody).then(response => {
      if (response.success) {
        let data = response.data;
        if (!Util.isEmpty(data)) {
          let resultData = {
            saveDays: data.saveDays,
            score: data.score,
            saveStatementDays: data.saveStatementDays,
          };
          this.setState({ stepNum: 2, resultData: resultData });
          data.categoryList.forEach(val => {
            val.score = Util.precisionRound(val.standardScore, 2);
          });
          this.renderRadar(data.categoryList);
        } else {
          this.setState({ stepNum: 1 });
        }
      } else {
        this.setState({
          error: {
            type: 'warn',
            title: response.errorMsg,
          },
        });
      }
    });
  }

  //渲染单月指标雷达图
  renderRadar(data) {
    let indicator = [];
    let userValue = [];

    data.forEach(item => {
      indicator.push({ name: item.categoryName, max: 10 });
      userValue.push(item.score);
    });
    let seriesData = [
      {
        value: userValue,
        name: '得分',
      },
      {
        value: [8, 8, 8, 8, 8],
        name: '标准分',
        tooltip: {
          show: false,
        },
      },
    ];
    this.setState({
      chartOpt1: StatisticsFns.getRadarOptMore(
        indicator,
        seriesData,
        '综合得分'
      ),
    });
  }

  handleCheckedChange = (index, itemIndex, valIndex) => event => {
    let allArr = this.state.questionAll;
    const checked = event.target.checked;
    allArr[index].childList[itemIndex].option[valIndex].checked = checked;
    this.setState({ questionAll: allArr });
  };

  handleRadioChange = (index, itemIndex) => event => {
    let allArr = this.state.questionAll;
    const value = event.target.value;
    allArr[index].childList[itemIndex].value = value;
    this.setState({ questionAll: allArr });
  };

  handleInfoChange = name => event => {
    let userInfo = this.state.userInfo;
    const value = event.target.value;
    userInfo[name] = value;
    this.error = {};
    this.setState({ userInfo: userInfo });
  };
  // 下一步
  nextClick() {
    let questionAll = this.state.questionAll;
    let questionNum = this.state.questionNum;
    let list = questionAll.find(n => n.pageNum === questionNum);
    let anArr = [];
    let err = false;
    list.childList.forEach(val => {
      let valObj = { qtnLineNo: val.id, ansContent: val.value };
      let regNum = /^\d{1,3}$/;
      if (val.type === 'text') {
        if (!regNum.test(val.value)) {
          this.errorMsg = '订单张数须为整数，且不能超过3位';
          err = true;
        } else if (parseInt(val.value, 10) === 0) {
          this.errorMsg = '订单张数不能为0';
          err = true;
        }
      }
      if (val.type === 'checkbox') {
        let string = '';
        val.option.forEach(item => {
          if (item.checked) {
            string = string === '' ? item.id : string + ';' + item.id;
          }
        });
        valObj.ansContent = string;
      }
      if (val.id === '99') {
        if (Util.isEmpty(val.value)) {
          this.errorMsg = 'ERP厂商不能为空';
          err = true;
        } else {
          let userInfo = this.state.userInfo;
          let erpObj = erpOption.find(n => n.code === val.value);
          userInfo.erpTypeCode = erpObj.code;
          userInfo.erpTypeName = erpObj.text;
          this.setState({ userInfo: userInfo });
        }
      } else {
        anArr.push(valObj);
      }
    });
    if (err) {
      this.setState({ showError: true });
      return;
    }
    let isEmptyObj = anArr.find(n => Util.isEmpty(n.ansContent));
    if (!Util.isEmpty(isEmptyObj)) {
      this.errorMsg = '请填写完所有题目';
      this.setState({ showError: true });
    } else {
      this.setState({
        questionNum: this.state.questionNum + 1,
        answerList: this.state.answerList.concat(anArr),
      });
      document.getElementById('quesBox').scrollTop = 0;
    }
  }

  saveClick() {
    let userInfo = this.state.userInfo;
    this.setState({ error2: false });
    // if (userInfo.positionCode) {
    //   let positionObj = vocationOption.find( (n) => n.code === userInfo.positionCode);
    //   userInfo.positionName = positionObj.text;
    //   this.setState({ userInfo: userInfo });
    // }
    if (!Validation.validateAll(this.validationConfig(), this.error)) {
      this.setState({ error2: true });
      return;
    }
    this.state.answerList.forEach(val => {
      if (val.qtnLineNo === '1') {
        val.ansContent = parseInt(val.ansContent, 10);
      }
    });
    let postbody = {
      apiPath: '/questionnaire/answer/save',
      itemList: this.state.answerList,
      ...userInfo,
      qtnXkNo: this.qtnXkNo,
    };
    this.setState({ error: null });
    Http.post('/api/mp', postbody).then(response => {
      if (response.success) {
        let data = response.data;
        if (!Util.isEmpty(data)) {
          let resultData = {
            saveDays: data.saveDays,
            score: data.score,
            saveStatementDays: data.saveStatementDays,
          };
          this.setState({ stepNum: 2, resultData: resultData });
          data.categoryList.forEach(val => {
            val.score = Util.precisionRound(val.standardScore, 2);
          });
          this.renderRadar(data.categoryList);
          window.scroll(0, 0);
          document.getElementById('quesBox2').scrollTop = 0;
        }
      } else {
        this.setState({
          error: {
            type: 'warn',
            title: response.errorMsg,
          },
        });
      }
    });
  }

  areaCodeChange = code => {
    let userInfo = this.state.userInfo;
    userInfo.mobileArea = code;
    this.setState({ userInfo: userInfo });
  };

  validationConfig() {
    let userInfo = this.state.userInfo;
    return {
      userName: { value: userInfo.userName, rules: ['required'] },
      companyName: { value: userInfo.companyName, rules: ['required'] },
    };
  }

  handleClose = () => {
    this.setState({ showError: false });
  };
  againClick = () => {
    let userInfo = {
      userName: '',
      companyName: '',
      mobileArea: '',
      mobile: '',
      erpTypeCode: '',
      erpTypeName: '',
      // 'positionCode':'',
      // 'positionName':'',
    };
    this.setState({
      questionAll: Util.mergeAll([basicAll]),
      stepNum: 1,
      questionNum: 1,
      answerList: [],
      userInfo: userInfo,
    });
  };

  render() {
    // const { data, actions } = this.props;
    const { classes } = this.props;
    if (this.state.error !== null) {
      return <Msg {...this.state.error} />;
    }
    let { stepNum, questionNum, questionAll, showError, resultData } =
      this.state;

    // let onEvents={
    //   'click': this.onChartClick.bind(this)
    // }
    //  onEvents={onEvents}
    return (
      <div className="surveyBox">
        {stepNum === 1 && (
          <div id="quesBox" className={classes.quesBox + ' scrollbar'}>
            <h2 className={classes.h2}>供应链管理评测</h2>
            {questionAll.map(
              (que, queIndex) =>
                questionNum === que.pageNum && (
                  <div key={que.pageNum} className={classes.pageBox}>
                    {que.title !== '' && (
                      <h4 className={classes.h4}>{que.title}</h4>
                    )}
                    {que.childList.map((item, itemIndex) => (
                      <div key={item.id}>
                        {item.type === 'text' && (
                          <div className={classes.quesList}>
                            <Card>
                              <CardContent>
                                <div>
                                  {item.num}.&nbsp;{item.txt}
                                  <Input
                                    placeholder={item.placeholder}
                                    onChange={this.handleRadioChange(
                                      queIndex,
                                      itemIndex
                                    )}
                                    type="number"
                                    value={item.value}
                                    className={classes.inputTxt}
                                    inputProps={{ 'aria-label': 'Description' }}
                                  />
                                  &nbsp;{item.lastTxt}
                                </div>
                              </CardContent>
                            </Card>
                          </div>
                        )}
                        {item.type === 'radio' && (
                          <div className={classes.quesList}>
                            <Card>
                              <CardContent>
                                <p>
                                  {item.num}.&nbsp;{item.txt}
                                  <span className="blue">&nbsp;(单选)</span>
                                </p>
                                <div className={classes.pl16}>
                                  <RadioGroup
                                    name={item.txt}
                                    className={classes.group}
                                    value={item.value || ''}
                                    onChange={this.handleRadioChange(
                                      queIndex,
                                      itemIndex
                                    )}
                                  >
                                    {item.option.map(val => (
                                      <FormControlLabel
                                        className="formControlLabel"
                                        key={val.id}
                                        value={val.id}
                                        control={<Radio color="primary" />}
                                        label={val.name}
                                      />
                                    ))}
                                  </RadioGroup>
                                </div>
                              </CardContent>
                            </Card>
                          </div>
                        )}
                        {item.type === 'checkbox' && (
                          <div className={classes.quesList}>
                            <Card>
                              <CardContent>
                                <p>
                                  {item.num}.&nbsp;{item.txt}
                                  <span className="blue">&nbsp;(多选)</span>
                                </p>
                                <div className={classes.pl16}>
                                  {item.option.map((val, j) => (
                                    <FormControlLabel
                                      key={j}
                                      className="formControlLabel"
                                      control={
                                        <Checkbox
                                          checked={val.checked}
                                          onChange={this.handleCheckedChange(
                                            queIndex,
                                            itemIndex,
                                            i
                                          )}
                                          value={val.id}
                                          color="primary"
                                        />
                                      }
                                      label={val.name}
                                    />
                                  ))}
                                </div>
                              </CardContent>
                            </Card>
                          </div>
                        )}
                        {item.type === 'select' && (
                          <div className={classes.quesList}>
                            <Card>
                              <CardContent>
                                <p>
                                  {item.num}.&nbsp;{item.txt}
                                </p>
                                <div className={classes.pl16}>
                                  <TextField
                                    select
                                    className={classes.quesSelect}
                                    onChange={this.handleRadioChange(
                                      queIndex,
                                      itemIndex
                                    )}
                                    value={item.value}
                                    margin="normal"
                                    variant="outlined"
                                  >
                                    {item.option.map(val => (
                                      <MenuItem
                                        value={val.code}
                                        key={val.code}
                                        name={val.text}
                                      >
                                        {val.text}
                                      </MenuItem>
                                    ))}
                                  </TextField>
                                  &nbsp;{item.lastTxt}
                                </div>
                              </CardContent>
                            </Card>
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                )
            )}
            {questionNum === questionAll.length + 1 && (
              <div>
                <div className={classes.quesList}>
                  <p className={classes.quesTitle}>基本信息</p>
                  <div className={classes.infoBox}>
                    <div className={classes.infoInputBox}>
                      <span className={classes.labelRed}>*</span>
                      <TextField
                        label="姓名"
                        className={classes.infoTextField}
                        onChange={this.handleInfoChange('userName')}
                        margin="normal"
                        variant="outlined"
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <AccountCircle />
                            </InputAdornment>
                          ),
                        }}
                      />
                      {this.error['userName'] && (
                        <p className="error-tip">{this.error['userName']}</p>
                      )}
                    </div>

                    <div className={classes.infoInputBox}>
                      <span className={classes.labelRed}>*</span>
                      <TextField
                        label="公司名称"
                        className={classes.infoTextField}
                        onChange={this.handleInfoChange('companyName')}
                        margin="normal"
                        variant="outlined"
                      />
                      {this.error['companyName'] && (
                        <p className="error-tip">{this.error['companyName']}</p>
                      )}
                    </div>
                    <div>
                      <TextField
                        label="手机"
                        className={classes.infoTextField}
                        onChange={this.handleInfoChange('mobile')}
                        margin="normal"
                        variant="outlined"
                        type="number"
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <AreaCode onChange={this.areaCodeChange} />
                            </InputAdornment>
                          ),
                          endAdornment: (
                            <InputAdornment position="end">
                              <PhoneIphone />
                            </InputAdornment>
                          ),
                        }}
                      />
                    </div>
                    {/* <div>
                      <TextField
                        select
                        label="部门"
                        className={classes.infoTextField}
                        onChange={this.handleInfoChange('positionCode')}
                        value={userInfo.positionCode}
                        margin="normal"
                        variant="outlined"
                      >
                        { vocationOption.map( val =>
                          <MenuItem value={val.code} key={val.code} name={val.text}>{val.text}</MenuItem>
                        )}
                      </TextField>
                    </div> */}
                  </div>
                </div>
              </div>
            )}

            <div className="wrap m-flex-box">
              {questionNum < questionAll.length + 1 && (
                <Button
                  size="large"
                  variant="contained"
                  onClick={() => this.nextClick()}
                  color="primary"
                  className={classes.button}
                >
                  下一步
                </Button>
              )}
              {questionNum === questionAll.length + 1 && (
                <Button
                  size="large"
                  variant="contained"
                  onClick={() => this.saveClick()}
                  color="primary"
                  className={classes.button}
                >
                  查看评测结果
                </Button>
              )}
            </div>
          </div>
        )}
        {stepNum === 2 && (
          <div id="quesBox2" className={classes.quesBox + ' scrollbar'}>
            <h3 className={classes.h3}>
              综合得分: &nbsp;<span className="red">{resultData.score}分</span>
            </h3>
            <Card className={classes.card}>
              <CardContent className={classes.cardContent}>
                <ReactEcharts
                  option={this.state.chartOpt1}
                  notMerge={true}
                  lazyUpdate={true}
                />
              </CardContent>
            </Card>
            {resultData.score !== 100 && (
              <div>
                <h4 className={classes.fruitH4}>管理建议</h4>
                <div className={classes.fruitBox}>
                  <h4 className={classes.fruitTitle}>订单管理效率</h4>
                  <p className={classes.fruitP}>
                    应用SRM可减少100%的订单发放工作量，而订单确认与差异处理工作量亦可以减少80%以上，并保证ERP交期的准确
                    {resultData.saveDays !== 0 ? (
                      <span>
                        ，预估可节省&nbsp;
                        <span className={classes.fruitRed}>
                          {resultData.saveDays}工作人天/月
                        </span>
                        。
                      </span>
                    ) : (
                      <span>。</span>
                    )}
                  </p>
                </div>

                <div className={classes.fruitBox}>
                  <h4 className={classes.fruitTitle}>过程精益能力</h4>
                  <p className={classes.fruitP}>
                    供应商来料较不受控，数字化管理供应商的来料行为，可以控制提前来料、减少错误与库存风险。
                  </p>
                </div>
                <div className={classes.fruitBox}>
                  <h4 className={classes.fruitTitle}>供应商评价能力</h4>
                  <p className={classes.fruitP}>
                    不能准确的评价供应商，建立数字化的供应商绩效考评体系是供应链优化的基础工作。
                  </p>
                </div>

                <div className={classes.fruitBox}>
                  <h4 className={classes.fruitTitle}>账务协作效率</h4>
                  <p className={classes.fruitP}>
                    建立电子化的供应商自动对账系统，可以将每月的对账时间减少至2～3天
                    {resultData.saveStatementDays !== 0 ? (
                      <span>
                        ，预估可节省对账工作量&nbsp;
                        <span className={classes.fruitRed}>
                          {resultData.saveStatementDays}天
                        </span>
                        。
                      </span>
                    ) : (
                      <span>。</span>
                    )}
                  </p>
                </div>

                <div className={classes.fruitBox}>
                  <h4 className={classes.fruitTitle}>采购寻源效率</h4>
                  <p className={classes.fruitP}>
                    建立数字化的询价招标与潜在供应商管理体系，可规范供应商引进流程，形成公平、有效的供应商优化机制。
                  </p>
                </div>
              </div>
            )}

            <div className="wrap m-flex-box">
              <Button
                size="large"
                variant="contained"
                onClick={this.againClick}
                color="primary"
                className={classes.button}
              >
                重新填写
              </Button>
            </div>
          </div>
        )}
        <Snackbar
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
          open={showError}
          onClose={this.handleClose}
          autoHideDuration={2000}
        >
          <SnackbarContent
            className={classes.snackbarContent}
            aria-describedby="client-snackbar"
            message={
              <span className={classes.message}>
                <WarningIcon className={classes.warningIcon} />
                {this.errorMsg}
              </span>
            }
          />
        </Snackbar>
      </div>
    );
  }
}

Survey.propTypes = {
  data: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired,
};

const mapStateToProps = state => {
  return {
    data: state.login,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(MobileActions, dispatch),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(Survey));
